let initialFields = {
  weightValue: null,
  apgarScore: null,
  resuscitation: "No",
};

export default initialFields;
